import { atom } from 'recoil';

export const projectTypesState = atom<string[]>({
  key: 'prpject-types',
  default: ['불러오는 중']
});
